<template>
  <div>

    <div class="d-block d-sm-block d-md-none">
      <GlobalSearchMobile/>
      <div class="banner-container-about" :style="`background-image: url(${banners[0].src})`"></div>
      <MenuMobile :icon="true" :nav="true" :show_user="false"></MenuMobile>
    </div>

    <div class="d-none d-sm-none d-md-block">
      <div id="carouselExampleIndicators" class="carousel slide mt-5">
        <div class="carousel-inner">
          <div v-for="(item,i) in banners" :key="i" :class="`carousel-item ${i == 0 ? 'active' : ''}`">
            <img class="d-block w-100" :src="item.src" alt="First slide">
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row mt-5 pa-sm-10">
        <div class="col">
          <div class="d-flex align-center">
            <h1 class="color-blue font-backward mr-10 title-history">Nuestra historia</h1>
            <img class="img-hoja-colaboraciones" src="@/assets/store/colaboraciones/20.png" alt="">
          </div> <br>
          <p
            class="color-blue font-general-r text-history"
            :style="`${screen == 'mobile' ? 'text-align: left' : ''}`"
            v-html="data_home_page.about_text"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data:() => ({
    banners: [
      {
        src: `${process.env.VUE_APP_URL_FILES}/images/about/nosotros.jpg`
      }
    ],
    screen: 'desktop'
  }),
  computed: {
    ...mapState(['data_home_page'])
  },
  mounted() {
    if (screen.width <= 425) {
      this.screen = 'mobile'
    }
  }
}
</script>
